import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const StyledMachineOperatingHoursDashboardChartBar = styled.div<{
  valueBarPercentage: number;
}>`
  ${({ theme: { kcc }, valueBarPercentage }): FlattenSimpleInterpolation => css`
    height: ${kcc.spacing.XS};

    .machine-operating-hours-dashboard-chart-bar__bar {
      height: 100%;
    }

    .machine-operating-hours-dashboard-chart-bar__background-bar {
      width: 100%;
      background-color: rgba(0, 0, 0, 0.06);
    }

    .machine-operating-hours-dashboard-chart-bar__value-bar {
      width: ${Number(valueBarPercentage).toString()}%;
      will-change: width;
      transition: all 0.3s;
      background-color: ${kcc.colors.PETROL[500]};
    }
  `}
`;
